export default __webpack_public_path__ + "static/media/33_3_1.340d6d5b.png";